import { PALETTE, DESIGN_TOKENS } from './RetroUI';

export const Scoreboard = ({ 
  teamA, 
  teamB, 
  currentInning, 
  totalInnings, 
  isTopInning, 
  outs 
}) => {
  // Truncate team names for mobile
  const truncateName = (name, maxLen = 10) => {
    return name.length > maxLen ? name.substring(0, maxLen) : name;
  };

  return (
    <div 
      className="relative"
      style={{
        background: PALETTE.scoreboardBg,
        border: `4px solid ${PALETTE.grass}`,
        padding: '12px 16px',
        boxShadow: `
          inset 0 0 0 2px ${PALETTE.grass}33,
          6px 6px 0px ${PALETTE.ink}
        `,
      }}
      data-testid="scoreboard"
    >
      {/* Corner rivets */}
      <div 
        className="absolute w-2.5 h-2.5 rounded-full"
        style={{ 
          top: '4px', left: '4px',
          background: `radial-gradient(circle at 30% 30%, ${PALETTE.grass}, ${PALETTE.grass}88)`,
        }} 
      />
      <div 
        className="absolute w-2.5 h-2.5 rounded-full"
        style={{ 
          top: '4px', right: '4px',
          background: `radial-gradient(circle at 30% 30%, ${PALETTE.grass}, ${PALETTE.grass}88)`,
        }} 
      />
      <div 
        className="absolute w-2.5 h-2.5 rounded-full"
        style={{ 
          bottom: '4px', left: '4px',
          background: `radial-gradient(circle at 30% 30%, ${PALETTE.grass}, ${PALETTE.grass}88)`,
        }} 
      />
      <div 
        className="absolute w-2.5 h-2.5 rounded-full"
        style={{ 
          bottom: '4px', right: '4px',
          background: `radial-gradient(circle at 30% 30%, ${PALETTE.grass}, ${PALETTE.grass}88)`,
        }} 
      />

      {/* Team Scores */}
      <div className="flex justify-between items-center mb-3">
        {/* Team A */}
        <div className="flex items-center gap-3">
          <span 
            style={{
              fontFamily: DESIGN_TOKENS.fonts.ui,
              fontSize: '10px',
              color: PALETTE.cream,
              maxWidth: '90px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {truncateName(teamA.name)}
          </span>
          <div 
            style={{
              fontFamily: DESIGN_TOKENS.fonts.ui,
              fontSize: '20px',
              color: PALETTE.scoreboardText,
              textShadow: `0 0 10px ${PALETTE.scoreboardText}`,
              padding: '4px 12px',
              background: PALETTE.ink,
              minWidth: '48px',
              textAlign: 'center',
            }}
          >
            {teamA.score}
          </div>
        </div>

        {/* Separator */}
        <span 
          style={{
            fontFamily: DESIGN_TOKENS.fonts.ui,
            fontSize: '14px',
            color: `${PALETTE.cream}66`,
          }}
        >
          -
        </span>

        {/* Team B */}
        <div className="flex items-center gap-3">
          <div 
            style={{
              fontFamily: DESIGN_TOKENS.fonts.ui,
              fontSize: '20px',
              color: PALETTE.scoreboardText,
              textShadow: `0 0 10px ${PALETTE.scoreboardText}`,
              padding: '4px 12px',
              background: PALETTE.ink,
              minWidth: '48px',
              textAlign: 'center',
            }}
          >
            {teamB.score}
          </div>
          <span 
            style={{
              fontFamily: DESIGN_TOKENS.fonts.ui,
              fontSize: '10px',
              color: PALETTE.cream,
              maxWidth: '90px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {truncateName(teamB.name)}
          </span>
        </div>
      </div>
      
      {/* Inning and Outs */}
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-2">
          <span 
            style={{
              fontFamily: DESIGN_TOKENS.fonts.ui,
              fontSize: '10px',
              color: PALETTE.scoreboardText,
              textShadow: `0 0 5px ${PALETTE.scoreboardText}`,
            }}
          >
            {isTopInning ? '▲' : '▼'}
          </span>
          <span 
            style={{
              fontFamily: DESIGN_TOKENS.fonts.ui,
              fontSize: '12px',
              color: PALETTE.scoreboardText,
              textShadow: `0 0 5px ${PALETTE.scoreboardText}`,
            }}
          >
            {currentInning}/{totalInnings}
          </span>
        </div>
        
        <div className="flex items-center gap-2">
          <span 
            style={{
              fontFamily: DESIGN_TOKENS.fonts.ui,
              fontSize: '9px',
              color: `${PALETTE.cream}99`,
            }}
          >
            OUTS
          </span>
          <div className="flex gap-1">
            {[0, 1, 2].map((i) => (
              <div
                key={i}
                style={{
                  width: '14px',
                  height: '14px',
                  border: `2px solid ${i < outs ? '#FF4444' : PALETTE.cream}44`,
                  borderRadius: '50%',
                  background: i < outs 
                    ? 'radial-gradient(circle at 30% 30%, #FF6666, #CC0000)' 
                    : `${PALETTE.ink}`,
                  boxShadow: i < outs 
                    ? '0 0 8px #FF4444' 
                    : 'none',
                }}
                data-testid={`out-indicator-${i}`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Scoreboard;
